import { createSlice } from "@reduxjs/toolkit";

interface ClientsStateType {
    ClientsError?: string | object | null | undefined | unknown,
    message: any,
    loading: any,
    clients?: any
}
export const initialState: ClientsStateType = {
    ClientsError: null,
    message: null,
    loading: false,
    clients: null,
};

const ClientsSlice = createSlice({
    name: "clients",
    initialState,
    reducers: {
        setClientsSuccessful(state, action) {
            state.clients = action.payload
        },
        setClientsFailed(state, action) {
            state.clients = action.payload
        },
        clearClients(state) {
            state.clients = null; // Reset `agency` state
        },
    },
});

export const {
    setClientsSuccessful,
    setClientsFailed,
    clearClients 
} = ClientsSlice.actions

export default ClientsSlice.reducer;